import React from "react";
import { MenaVstupy, PercentaVstupy, IntegerVstupy } from "../vstupneKomponenty";

export default function HypoZavazky({
  pocetziadatelov,
  aktivnyZavazkyTab,
  setAktivnyZavazkyTab,

  Hypoobjem,
  setHypoobjem,
  Hyposplatnost,
  setHyposplatnost,
  Hyposadzba,
  setHyposadzba,
  Hyposplatka,
  setHyposplatka,
  Hypofixacia,
  setHypofixacia,
  Ostatneobjem,
  setOstatneobjem,
  Ostatnesplatka,
  setOstatnesplatka,

  Hypoobjem2,
  setHypoobjem2,
  Hyposplatnost2,
  setHyposplatnost2,
  Hyposadzba2,
  setHyposadzba2,
  Hyposplatka2,
  setHyposplatka2,
  Hypofixacia2,
  setHypofixacia2,
  Ostatneobjem2,
  setOstatneobjem2,
  Ostatnesplatka2,
  setOstatnesplatka2,

  Hypoobjem3,
  setHypoobjem3,
  Hyposplatnost3,
  setHyposplatnost3,
  Hyposadzba3,
  setHyposadzba3,
  Hyposplatka3,
  setHyposplatka3,
  Hypofixacia3,
  setHypofixacia3,
  Ostatneobjem3,
  setOstatneobjem3,
  Ostatnesplatka3,
  setOstatnesplatka3,

  Hypoobjem4,
  setHypoobjem4,
  Hyposplatnost4,
  setHyposplatnost4,
  Hyposadzba4,
  setHyposadzba4,
  Hyposplatka4,
  setHyposplatka4,
  Hypofixacia4,
  setHypofixacia4,
  Ostatneobjem4,
  setOstatneobjem4,
  Ostatnesplatka4,
  setOstatnesplatka4,
}) {
  return (
    <>
      <div className="card-section">
                  <div className="card-header">
                  <h2>Celkové záväzky:</h2>
      
                  <div className="applicant-tabs">
                    {[1, 2, 3, 4].map((i) => {
                      const jePovoleny = i <= Number(pocetziadatelov || 1);
                      const jeAktivny = i === aktivnyZavazkyTab;
      
                      return (
                        <button
                          key={i}
                          type="button"
                          className={`applicant-tab ${jeAktivny ? 'is-active' : ''} ${!jePovoleny ? 'is-disabled' : ''}`}
                          onClick={() => { if (jePovoleny) setAktivnyZavazkyTab(i); }}
                          disabled={!jePovoleny}
                        >
                          Žiadateľ {i}
                        </button>
                      );
                    })}
                  </div>
                  </div>
      
                    {(() => {
                      const aktivnyHypoobjem =
                        aktivnyZavazkyTab === 1 ? Hypoobjem :
                        aktivnyZavazkyTab === 2 ? Hypoobjem2 :
                        aktivnyZavazkyTab === 3 ? Hypoobjem3 : Hypoobjem4;
      
                      const setAktivnyHypoobjem =
                        aktivnyZavazkyTab === 1 ? setHypoobjem :
                        aktivnyZavazkyTab === 2 ? setHypoobjem2 :
                        aktivnyZavazkyTab === 3 ? setHypoobjem3 : setHypoobjem4;
      
                      const aktivnyHyposplatka =
                        aktivnyZavazkyTab === 1 ? Hyposplatka :
                        aktivnyZavazkyTab === 2 ? Hyposplatka2 :
                        aktivnyZavazkyTab === 3 ? Hyposplatka3 : Hyposplatka4;
      
                      const setAktivnyHyposplatka =
                        aktivnyZavazkyTab === 1 ? setHyposplatka :
                        aktivnyZavazkyTab === 2 ? setHyposplatka2 :
                        aktivnyZavazkyTab === 3 ? setHyposplatka3 : setHyposplatka4;
      
                      const aktivnyHypofixacia =
                        aktivnyZavazkyTab === 1 ? Hypofixacia :
                        aktivnyZavazkyTab === 2 ? Hypofixacia2 :
                        aktivnyZavazkyTab === 3 ? Hypofixacia3 : Hypofixacia4;
      
                      const setAktivnyHypofixacia =
                        aktivnyZavazkyTab === 1 ? setHypofixacia :
                        aktivnyZavazkyTab === 2 ? setHypofixacia2 :
                        aktivnyZavazkyTab === 3 ? setHypofixacia3 : setHypofixacia4;
      
                      const aktivnyHyposadzba =
                        aktivnyZavazkyTab === 1 ? Hyposadzba :
                        aktivnyZavazkyTab === 2 ? Hyposadzba2 :
                        aktivnyZavazkyTab === 3 ? Hyposadzba3 : Hyposadzba4;
      
                      const setAktivnyHyposadzba =
                        aktivnyZavazkyTab === 1 ? setHyposadzba :
                        aktivnyZavazkyTab === 2 ? setHyposadzba2 :
                        aktivnyZavazkyTab === 3 ? setHyposadzba3 : setHyposadzba4;
      
                      const aktivnyHyposplatnost =
                        aktivnyZavazkyTab === 1 ? Hyposplatnost :
                        aktivnyZavazkyTab === 2 ? Hyposplatnost2 :
                        aktivnyZavazkyTab === 3 ? Hyposplatnost3 : Hyposplatnost4;
      
                      const setAktivnyHyposplatnost =
                        aktivnyZavazkyTab === 1 ? setHyposplatnost :
                        aktivnyZavazkyTab === 2 ? setHyposplatnost2 :
                        aktivnyZavazkyTab === 3 ? setHyposplatnost3 : setHyposplatnost4;
      
                      const aktivnyOstatneobjem =
                        aktivnyZavazkyTab === 1 ? Ostatneobjem :
                        aktivnyZavazkyTab === 2 ? Ostatneobjem2 :
                        aktivnyZavazkyTab === 3 ? Ostatneobjem3 : Ostatneobjem4;
      
                      const setAktivnyOstatneobjem =
                        aktivnyZavazkyTab === 1 ? setOstatneobjem :
                        aktivnyZavazkyTab === 2 ? setOstatneobjem2 :
                        aktivnyZavazkyTab === 3 ? setOstatneobjem3 : setOstatneobjem4;
      
                      const aktivnyOstatnesplatka =
                        aktivnyZavazkyTab === 1 ? Ostatnesplatka :
                        aktivnyZavazkyTab === 2 ? Ostatnesplatka2 :
                        aktivnyZavazkyTab === 3 ? Ostatnesplatka3 : Ostatnesplatka4;
      
                      const setAktivnyOstatnesplatka =
                        aktivnyZavazkyTab === 1 ? setOstatnesplatka :
                        aktivnyZavazkyTab === 2 ? setOstatnesplatka2 :
                        aktivnyZavazkyTab === 3 ? setOstatnesplatka3 : setOstatnesplatka4;
      
                      return (
      
                    <div className="zavazky-rozlozenie">
                    <div className="zavazky-lava">
                      <h3>Hypotéky</h3>
      
                      <div className="form-group form-group--cols2">
                        <div className="form form--l">
                          <MenaVstupy
                            value={aktivnyHypoobjem}
                            onChange={setAktivnyHypoobjem}
                            maxDigits={7}
                            suffix="€"
                            placeholder=" "
                          />
                          <label className="form_label">Aktuálny zostatok</label>
                        </div>
      
                        <div className="form form--m">
                          <MenaVstupy
                            value={aktivnyHyposplatka}
                            onChange={setAktivnyHyposplatka}
                            maxDigits={4}
                            suffix="€"
                            placeholder=" "
                          />
                          <label className="form_label">Aktuálna splátka</label>
                        </div>
                      </div>
      
                    <div className="form-group form-group--cols3">
                      <div className="form form--s">
                        <IntegerVstupy
                          value={aktivnyHypofixacia}
                          onChange={setAktivnyHypofixacia}
                          maxDigits={2}   
                          min={0}
                          max={99}
                          placeholder=" "
                        />
                        <label className="form_label">Fixácia (r)</label>
                      </div>
                    
                      <div className="form form--s">
                        <PercentaVstupy
                          value={aktivnyHyposadzba}
                          onChange={setAktivnyHyposadzba}
                          maxInt={2}
                          placeholder=" "
                        />
                        <label className="form_label">Úroková sadzba</label>
                      </div>
      
                      <div className="form form--s">
                        <IntegerVstupy
                          value={aktivnyHyposplatnost}
                          onChange={setAktivnyHyposplatnost}
                          maxDigits={3}   
                          min={0}
                          max={999}
                          placeholder=" "
                        />
                        <label className="form_label">Zost. splatnosť (m)</label>
                      </div>
                    </div>
                  </div>
      
                  <div className="zavazky-delic" aria-hidden="true" />
                  
                  <div className="zavazky-prava">
                    <h3>Ostatné úvery</h3>
      
                    <div className="form-group">
                      <div className="form form--l">
                        <MenaVstupy
                          value={aktivnyOstatneobjem}
                          onChange={setAktivnyOstatneobjem}
                          maxDigits={7}     
                          suffix="€"
                          placeholder=" "
                        />
                        <label className="form_label">Aktuálny zostatok</label>
                      </div>
                    </div>
      
                      <div className="form-group">
                        <div className="form form--m">
                          <MenaVstupy
                            value={aktivnyOstatnesplatka}
                            onChange={setAktivnyOstatnesplatka}
                            maxDigits={4}     
                            suffix="€"
                            placeholder=" "
                          />
                          <label className="form_label">Aktuálna splátka</label>
                        </div>
                       </div> 
                     </div> 
                  </div>
                  );
                  })()} 
                </div>
    </>
  );
}